import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const { i18n } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  // Cookie banner translations
  const translations = {
    it: {
      title: 'Questo sito utilizza i cookie',
      description: 'Utilizziamo cookie tecnici necessari per il funzionamento del sito e cookie analitici per migliorare la tua esperienza. Puoi scegliere quali cookie accettare.',
      moreInfo: 'Maggiori informazioni',
      necessary: 'Solo Necessari',
      acceptAll: 'Accetta Tutti'
    },
    en: {
      title: 'This site uses cookies',
      description: 'We use necessary technical cookies for the site to function and analytical cookies to improve your experience. You can choose which cookies to accept.',
      moreInfo: 'More information',
      necessary: 'Necessary Only',
      acceptAll: 'Accept All'
    },
    de: {
      title: 'Diese Website verwendet Cookies',
      description: 'Wir verwenden technische Cookies, die für das Funktionieren der Website notwendig sind, und analytische Cookies zur Verbesserung Ihrer Erfahrung. Sie können wählen, welche Cookies akzeptiert werden.',
      moreInfo: 'Weitere Informationen',
      necessary: 'Nur Notwendige',
      acceptAll: 'Alle Akzeptieren'
    },
    fr: {
      title: 'Ce site utilise des cookies',
      description: 'Nous utilisons des cookies techniques nécessaires au fonctionnement du site et des cookies analytiques pour améliorer votre expérience. Vous pouvez choisir les cookies à accepter.',
      moreInfo: 'Plus d\'informations',
      necessary: 'Nécessaires Uniquement',
      acceptAll: 'Accepter Tout'
    },
    es: {
      title: 'Este sitio utiliza cookies',
      description: 'Utilizamos cookies técnicas necesarias para el funcionamiento del sitio y cookies analíticas para mejorar tu experiencia. Puedes elegir qué cookies aceptar.',
      moreInfo: 'Más información',
      necessary: 'Solo Necesarias',
      acceptAll: 'Aceptar Todas'
    }
  };

  const t = translations[i18n.language] || translations.it;

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-2xl border-t-4 border-blue-600" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              🍪 {t.title}
            </h3>
            <p className="text-gray-700 text-sm">
              {t.description}
              {' '}
              <Link to="/cookie-policy" className="text-blue-600 hover:text-blue-700 underline">
                {t.moreInfo}
              </Link>
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={acceptNecessary}
              className="px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-semibold text-sm"
              data-testid="cookie-reject-btn"
            >
              {t.necessary}
            </button>
            <button
              onClick={acceptAll}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold text-sm"
              data-testid="cookie-accept-btn"
            >
              {t.acceptAll}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
